"use client";

import { useLocalNum } from "@faire/localization/react/useLocalNum";
import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import React from "react";

import { BADGE_VALUE_TRUNCATION_THRESHOLD } from "./consts";

type IProps = Omit<
  React.HTMLAttributes<HTMLParagraphElement>,
  "className" | "children"
> & {
  children: number;
  showExact: boolean;
};

export const BadgeContent: React.FC<IProps> = ({
  children,
  showExact,
  ...props
}) => {
  const value = useLocalizedBadgeValue(children, showExact);
  return (
    <span {...props} className="fs-badge__content">
      {value}
    </span>
  );
};

const useLocalizedBadgeValue = (value: number, showExact: boolean) => {
  const { strictLocalize } = useStrictLocalization();
  const { localNum } = useLocalNum();
  if (!showExact && value > BADGE_VALUE_TRUNCATION_THRESHOLD) {
    return strictLocalize(
      {
        id: "KQEYfj",
        defaultMessage: "{badgeValueLocalizedNumber}+",
        description: {
          text: 'The capped badge value when it exceeds 99, displayed as 99+. "badgeValueLocalizedNumber" is always 99.',
          img: "https://cdn.faire.com/fastly/090b763982b43069c19291d50a7d838d9815f9a8116b5b9aea52e4806eeaa81b.png",
        },
      },
      {
        badgeValueLocalizedNumber: localNum(BADGE_VALUE_TRUNCATION_THRESHOLD),
      }
    );
  }
  return localNum(value);
};
